module.exports = __webpack_public_path__ + "media/images/expert__denise-herrmann-wick-2514292af253eec356da682b2800e9b5.png";